/** @format */

export const DEFAULT_VALUES = {
  desiredDate: null,
  desiredTime: '',
  phone: '',
  email: '',
};

export const ID_ROOT = 'book-demo-form';
export const ID_SUBMIT = 'book-demo-submit';

export const TIME_OPTIONS = [
  {value: '09:00', text: '09:00'},
  {value: '10:00', text: '10:00'},
  {value: '11:00', text: '11:00'},
  {value: '12:00', text: '12:00'},
  {value: '13:00', text: '13:00'},
  {value: '14:00', text: '14:00'},
  {value: '15:00', text: '15:00'},
  {value: '16:00', text: '16:00'},
  {value: '17:00', text: '17:00'},
  {value: '18:00', text: '18:00'},
];
